import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import { BADGE_CACHE_FIELDS } from '@/client/exchanges/cacheExchange/constants';
import invalidateFields, {
  type FieldInvalidationCache,
} from '@/client/exchanges/cacheExchange/invalidateFields';

export function invalidateBadgeFields(cache: FieldInvalidationCache) {
  invalidateFields(BADGE_CACHE_FIELDS, cache);
}

export default function update_badge(
  _parent: unknown,
  _args: unknown,
  cache: Cache,
  _info: ResolveInfo,
) {
  invalidateBadgeFields(cache);
}
